import { useContext } from 'react';
import { AuthContext } from '../services/contexts/auth';

export default function useAuth() {
    const context = useContext(AuthContext)
    // console.log('context', context);
 return context;
}